import _ from 'lodash';
import { DOM } from '../../browser-helpers/dom-factory';
import { Events } from '../../browser-constants/events';
import { BaseTool } from '../base-tool';
import { ShortcutKeys } from '../../browser-constants/shortcut-keys';
import { isShortcutKeyOnly } from '../../browser-helpers/is-shortcut-key-only';
import { TranslationManager } from '../../toolbar-managers/translation-manager/translation-manager';
import { SvgPaths, getSvgIcon } from '../../ui-icons/get-svg-icon/get-svg-icon';

const FILENAME = 'refresh-tool.js';
const CLASS__TOOL_BUTTON = 'oltb-tool-button';
const I18N__BASE = 'tools.refreshTool';

const DefaultOptions = Object.freeze({
  onInitiated: undefined,
  onClicked: undefined,
});

/**
 * About:
 * Reload the application
 *
 * Description:
 * The entire browser window will reload.
 */
class RefreshTool extends BaseTool {
  constructor(options = {}) {
    super({
      filename: FILENAME,
    });

    const icon = getSvgIcon({
      path: SvgPaths.arrowClockwise.stroked,
      class: `${CLASS__TOOL_BUTTON}__icon`,
    });

    const i18n = TranslationManager.get(I18N__BASE);
    const button = DOM.createElement({
      element: 'button',
      html: icon,
      class: CLASS__TOOL_BUTTON,
      attributes: {
        type: 'button',
        'data-tippy-content': ShortcutKeys.refreshPageTool
          ? `${i18n.title} (${ShortcutKeys.refreshPageTool})`
          : `${i18n.title}`,
        'data-tippy-content-post': `(${ShortcutKeys.refreshPageTool})`,
        'data-oltb-i18n': `${I18N__BASE}.title`,
      },
      listeners: {
        click: this.onClickTool.bind(this),
      },
    });

    DOM.appendChildren(this.element, [button]);

    this.button = button;
    this.options = _.merge(_.cloneDeep(DefaultOptions), options);

    this.attachGlobalListeners();

    // Note:
    // @Consumer callback
    if (this.options.onInitiated) {
      this.options.onInitiated();
    }
  }

  attachGlobalListeners() {
    this.onWindowKeyUpBind = this.#onWindowKeyUp.bind(this);
    window.addEventListener(Events.browser.keyUp, this.onWindowKeyUpBind);
  }

  detachGlobalListeners() {
    window.removeEventListener(Events.browser.keyUp, this.onWindowKeyUpBind);
  }

  //--------------------------------------------------------------------
  // # Section: Overridden
  //--------------------------------------------------------------------
  getName() {
    return super.getName();
  }

  onClickTool(event) {
    super.onClickTool(event);
    this.momentaryActivation();

    // Note:
    // @Consumer callback
    if (this.options.onClicked) {
      this.options.onClicked();
    }
  }

  //--------------------------------------------------------------------
  // # Section: Tool Control
  //--------------------------------------------------------------------
  momentaryActivation() {
    this.doWindowReload();
  }

  //--------------------------------------------------------------------
  // # Section: Browser Events
  //--------------------------------------------------------------------
  #onWindowKeyUp(event) {
    if (isShortcutKeyOnly(event, ShortcutKeys.refreshPageTool)) {
      this.onClickTool(event);
    }
  }

  //--------------------------------------------------------------------
  // # Section: Tool DoActions
  //--------------------------------------------------------------------
  doWindowReload() {
    window.location.reload();
  }
}

export { RefreshTool };
